import { render } from "./Footer.vue?vue&type=template&id=350b86de&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=350b86de&lang=stylus&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-350b86de"]])

export default __exports__